import type { Carer } from '@lmc/ts-common'

/**
 * Builds the minimal Carer shape used by LastUpdateBox from API `updatedByData.name`
 * (full name split into first/last for display).
 */
export function lastUpdateCarerFromUpdatedByData(
  updatedByData?: { name?: string } | null
): Carer | undefined {
  const updatedByName = updatedByData?.name?.trim()
  if (!updatedByName) {
    return undefined
  }
  const [firstName, ...lastNameParts] = updatedByName.split(' ')
  const lastName = lastNameParts.join(' ')
  return {
    name: {
      first: firstName || updatedByName,
      last: lastName
    }
  } as Carer
}
